import { motion } from "framer-motion";
import React from "react";
import projectPic4 from '../assests/cafe.png';
import projectPic5 from '../assests/friend.png';
import figmaPic from '../assests/figma.png';
import projectPic3 from '../assests/Silent Desk.png';
import projectPic2 from '../assests/tailwindKit.png';
import projectPic1 from '../assests/TextEditor.png';
const projectsData = [
    {
        id: 1,
        title: "Anonymous Messaging App ",
        tags: "React • Node.js • Express • MongoDB • JWT",
        img: projectPic3,
        live: "https://frontend-silent-desk.onrender.com/",
        // repo: "https://github.com/madihamalghani/frontend-silent-desk.git",
    },
    {
        id: 2,
        title: "Multi Theme Text Editor",
        tags: "React • Bootstrap",
        img: projectPic1,
        live: "https://react-multi-theme-text-editor.vercel.app/home",
        repo: "https://github.com/madihamalghani/React-Multi-Theme-Text-Editor.git",
    },
    {
        id: 3,
        title: "Tailwind Kit",
        tags: "Javascript  • React  • Tailwind CSS",
        img: projectPic2,
        live: "https://tailwind-kit-one.vercel.app/",
        repo: "https://github.com/madihamalghani/Tailwind-CSS.git",
    },
    {
        id: 4,
        title: "Figma Design demo",
        tags: "Swap Effect • Interactions • Variants  ",
        img: figmaPic,
        live: "https://www.figma.com/proto/GLCnKQdUgE5zSK1CWKnNKp/Little-lemon-reserve-a-table?node-id=23-54&t=KvGDQ7nyAZTQTnuZ-1&scaling=scale-down&content-scaling=fixed&page-id=23%3A53&starting-point-node-id=23%3A106",
        // repo: "https://github.com/madihamalghani/single-linked-list-create.git",
    },
    {
        id: 5,
        title: "Say It",
        tags: "HTML • CSS • Javascript",
        img: projectPic5,
        live: "https://madihamalghani.github.io/Bestie-Love-Confession-A-Fun-Do-You-Love-Me-App/",
        repo: "https://github.com/madihamalghani/Bestie-Love-Confession-A-Fun-Do-You-Love-Me-App.git",
    },
    {
        id: 6,
        title: "Cafe Shop",
        tags: "HTML • CSS • Javascript",
        img: projectPic4,
        live: "https://madihamalghani.github.io/Cafe-website/",
        repo: "https://github.com/madihamalghani/Cafe-website.git",
    },
];

const Projects = () => {
    return (
        <section id="projects" className="projects-section">
            <h3 className="projects-heading">Selected Projects</h3>
            <div className="row g-4">
                {projectsData.map((p, index) => (
                    <motion.div
                        className="col-md-4"
                        key={p.id}
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5, delay: index * 0.15, ease: "easeOut" }}
                        viewport={{ once: true }}
                    >
                        <div className="project-card">
                            <div className="project-image">
                                <img src={p.img} alt={p.title} />
                            </div>
                            <div className="project-body">
                                <h5>{p.title}</h5>
                                <div className="project-tags">{p.tags}</div>
                                <div className="d-flex justify-content-between align-items-center mt-3 w-50">
                                    <div>
                                        <a
                                            className="btn btn-sm btn-outline-secondary me-2 "
                                            href={p.live}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Live demo
                                        </a>
                                        {/* <a
                                            className="btn btn-sm btn-outline-secondary"
                                            href={p.repo}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Code
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default Projects;
